// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.el-checkbox-group{font-size:0;line-height:0}`, "",{"version":3,"sources":["webpack://./../../../node_modules/element-plus/theme-chalk/el-checkbox-group.css"],"names":[],"mappings":"AAAA,mBAAmB,WAAW,CAAC,aAAa","sourcesContent":[".el-checkbox-group{font-size:0;line-height:0}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
